import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './queries'

// User mutations
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

export const UPDATE_USER_FAVORITES = gql`
  mutation UpdateUserFavorites($input: UpdateUserFavoritesInput!) {
    updateUserFavorites(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

// Watchlist mutations
export const CREATE_WATCHLIST = gql`
  mutation CreateWatchlist($input: CreateWatchlistInput!) {
    createWatchlist(input: $input) {
      id
      name
      userId
      projectIds
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_WATCHLIST = gql`
  mutation UpdateWatchlist($input: UpdateWatchlistInput!) {
    updateWatchlist(input: $input) {
      id
      name
      userId
      projectIds
      createdAt
      updatedAt
    }
  }
`

export const DELETE_WATCHLIST = gql`
  mutation DeleteWatchlist($watchlistId: String!) {
    deleteWatchlist(watchlistId: $watchlistId)
  }
`

export const ADD_PROJECT_TO_WATCHLIST = gql`
  mutation AddProjectToWatchlist($input: AddProjectToWatchlistInput!) {
    addProjectToWatchlist(input: $input) {
      id
      name
      userId
      projectIds
      createdAt
      updatedAt
    }
  }
`

export const REMOVE_PROJECT_FROM_WATCHLIST = gql`
  mutation RemoveProjectFromWatchlist($input: RemoveProjectFromWatchlistInput!) {
    removeProjectFromWatchlist(input: $input) {
      id
      name
      userId
      projectIds
      createdAt
      updatedAt
    }
  }
`


// Suggestion mutations
export const CREATE_SUGGESTION = gql`
  mutation CreateSuggestion($input: CreateSuggestionInput!) {
    createSuggestion(input: $input) {
      id
      message
      createdAt
    }
  }
`
